export default __webpack_public_path__ + "static/media/sel.2a1750d6b1c3a0d97401c4b7a2ef528b.svg";